import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'topnavigationlayout',
  template: require('./topNavigationlayout.template.html'),
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class TopNavigationLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/layouts/topNavigationlayout.component.ts